import {
  REQUEST_GET_FIRMS_SUCCESS, REQUEST_GET_FIRMS_FAILED,
  REQUEST_REMOVE_FIRM_SUCCESS, REQUEST_REMOVE_FIRM_FAILED,
  RESET_FIRMS
} from "../actions/firms_actions";


const initialState = {
  firms: []
}


export const firmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_FIRMS_SUCCESS: {
      return {
        ...state,
        firms: [...action.payload],
      }
    }
    case REQUEST_GET_FIRMS_FAILED: {
      return {
        ...state,
        firms: []
      }
    }
    case REQUEST_REMOVE_FIRM_SUCCESS: {
      return {
        ...state,
        firms: [...action.payload],
      }
    }
    case REQUEST_REMOVE_FIRM_FAILED: {
      return {
        ...state,
        firms: []
      }
    }
    case RESET_FIRMS: {
      return {
        ...state,
        firms: []
      }
    }
    default: return state;
  }
}
